import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var breadcrumbs_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M4 13.5h3v-3H4v3Zm6-3.5 2 2-2 2 1 1 3-3-3-3-1 1Zm7 .5v3h3v-3h-3Z" }) });
export {
  breadcrumbs_default as default
};
//# sourceMappingURL=breadcrumbs.js.map
